import { render, staticRenderFns } from "./StudentClassroomAssessments.vue?vue&type=template&id=911ed2f0&"
import script from "./StudentClassroomAssessments.vue?vue&type=script&lang=js&"
export * from "./StudentClassroomAssessments.vue?vue&type=script&lang=js&"
import style0 from "./StudentClassroomAssessments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports